module.exports = __webpack_public_path__ + "static/img/11.679d87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/11.png
// module id = ASkI
// module chunks = 0